<template>
  <div id="service-form">
    <div class="vx-col md:w-2/2 w-full mb-base">

      <router-link
        class="form-header__back-button"
        tag="a"
        :to="{ name: 'Services', params: { id: form.cityId || $route.query.cityId } }">
        &#8249; Все услуги
      </router-link>

      <div class="form-header">
        <div class="form-header__title">
          <span>Основная услуга</span>
        </div>
        <div class="form-header__edit">
          <v-select
            v-model="form.status"
            :options="Object.keys(statuses).map(value => ({ value, label: statuses[value].text }))"
            :reduce="type => type.value"
            :class="statuses[form.status] ? statuses[form.status].color : ''"
            :clearable="false"
            :disabled="isDisabled"
            class="pay-status service-status"
            placeholder="Статус услуги"
            label="label" />
          <template v-if="userRole === 'admin'">
            <vs-button
              v-if="isEdit"
              :disabled="!validateForm"
              color="primary"
              type="filled"
              @click="onEdit">
              <img src="@/assets/icons/check.svg" />
            </vs-button>
            <vs-button
              v-else
              :disabled="!validateForm"
              color="primary"
              type="filled"
              @click="onAdd">
              <img src="@/assets/icons/check.svg" />
            </vs-button>
          </template>
        </div>
      </div>

      <div
        ref="loading"
        class="form service-form">

        <div class="form__column">
          <div class="form__field">
            <span
              :class="{ 'form__field-label_hidden': !form.unitType }"
              class="form__field-label form__field-label_select">
              Тип юнита
            </span>
            <v-select
              v-model="form.unitType"
              :options="Object.keys(unitTypes).map(value => ({ value, label: unitTypes[value] }))"
              :reduce="type => type.value"
              :class="{ 'validate-error': errors.has('unitType') }"
              :clearable="false"
              :disabled="isDisabled"
              placeholder="Тип юнита"
              label="label"
              name="unitType"
              v-validate="'required'" />
          </div>

          <div
            :class="{ 'active': form.newbieCleanersCount > 0 }"
            class="form__field input-number-buttons cleaners-count">
            <vs-input-number
              v-model="form.newbieCleanersCount"
              :disabled="isDisabled"
              class="cleaners-count__input" />
            <span class="cleaners-count__label" >
              Ограниченное кол-во новичков
            </span>
          </div>

          <div
            :class="{ 'active': form.universalCleanersCount > 0 }"
            class="form__field input-number-buttons cleaners-count">
            <vs-input-number
              v-model="form.universalCleanersCount"
              :disabled="isDisabled"
              class="cleaners-count__input" />
            <span class="cleaners-count__label" >
              Ограниченное кол-во универаслов
            </span>
          </div>

          <div
            v-if="form.unitType === 'room'"
            :class="{ 'active': form.isSubscribeAvailable > 0 }"
            class="form__field subscribe">
            <vs-checkbox
              v-model="form.isSubscribeAvailable"
              :disabled="isDisabled"
              class="subscribe__input">
              Возможна подписка
            </vs-checkbox>
          </div>
        </div>

        <div class="form__column">
          <div class="form__field">
            <span
              :class="{ 'form__field-label_hidden': !form.name }"
              class="form__field-label form__field-label_select">
              Название
            </span>
            <vs-input
              v-model="form.name"
              :class="{ 'validate-error': errors.has('name') || getMessage('name') }"
              :disabled="isDisabled"
              class="w-full"
              name="name"
              placeholder="Название" />
            <span
              v-if="getMessage('name')"
              class="form__validate-message">
              {{ getMessage('name').message }}
            </span>
          </div>

          <div class="form__field">
            <span
              :class="{ 'form__field-label_hidden': !form.descriptionLink }"
              class="form__field-label form__field-label_select">
              Ссылка на описание
            </span>
            <vs-input
              v-model="form.descriptionLink"
              :class="{ 'validate-error': errors.has('descriptionLink') }"
              :disabled="isDisabled"
              class="w-full"
              name="descriptionLink"
              placeholder="Ссылка на описание" />
          </div>

          <div class="form__field">
            <span
              :class="{ 'form__field-label_hidden': !form.descriptionPrice }"
              class="form__field-label form__field-label_select">
              Инфо о стоимости
            </span>
            <vs-input
              v-model="form.descriptionPrice"
              :class="{ 'validate-error': errors.has('descriptionPrice') }"
              :disabled="isDisabled"
              class="w-full"
              name="descriptionPrice"
              placeholder="Инфо о стоимости" />
          </div>
        </div>

        <div class="form__column">
          <div class="form__field">
            <span
              :class="{ 'form__field-label_hidden': !form.description }"
              class="form__field-label form__field-label_select">
              Краткое описание
            </span>
            <textarea
              v-model="form.description"
              :disabled="isDisabled"
              placeholder="Краткое описание" />
          </div>

          <div
            v-if="form.unitType === 'room'"
            class="form__field">
            <span
              :class="{ 'form__field-label_hidden': form.initialDiscountAmount === '' || form.initialDiscountAmount === undefined }"
              class="form__field-label form__field-label_select">
              Размер скидки для новых клиентов
            </span>
            <vs-input-number
              v-model="form.initialDiscountAmount"
              :min="0"
              :disabled="isDisabled || form.shouldIgnoreInitialDiscount"
              placeholder="Размер скидки для новых клиентов"
              class="w-full" />
          </div>
          <div
            v-if="form.unitType === 'room'"
            class="form__field">
            <vs-checkbox
              v-model="form.shouldIgnoreInitialDiscount"
              :disabled="isDisabled"
              class="subscribe__input">
              Отключить скидку для новых пользователей
            </vs-checkbox>
          </div>
        </div>
      </div>

      <services-list
        v-if="form.unitType === 'services' && isEdit"
        :main-service-id="+$route.params.id"
        @services-update="setServicesIds" />

      <div
        v-if="form.unitType === 'room' || form.unitType === 'm2'"
        class="form-header price">
        <div class="form-header__title">
          <span>Цены</span>
        </div>
      </div>

      <div
        v-if="form.unitType === 'room'"
        class="form service-price">

        <div class="form__column row-number">
          <div class="form__field title">
            <p />
          </div>
          <div
            v-for="index in 5"
            :key="index"
            class="form__field">
            <p class="index">{{ index }}</p>
          </div>
          <div class="form__field">
            <p class="index">>5</p>
          </div>
        </div>

        <div class="form__column right-line">
          <div class="form__field title">
            <p />
          </div>
          <div
            v-for="index in 5"
            :key="index"
            class="form__field_few">
            <div class="form__field">
              <span
                :class="{ 'form__field-label_hidden': form.roomsPrices[index].baseCost === '' || form.roomsPrices[index].baseCost === undefined }"
                class="form__field-label form__field-label_select">
                Цена
              </span>
              <vs-input-number
                v-model="form.roomsPrices[index].baseCost"
                :min="0"
                :disabled="isDisabled"
                placeholder="Цена"
                class="w-full" />
            </div>
            <div class="form__field">
              <span
                :class="{ 'form__field-label_hidden': form.roomsPrices[index].cleanerCost === '' || form.roomsPrices[index].cleanerCost === undefined }"
                class="form__field-label form__field-label_select">
                Ставка
              </span>
              <vs-input-number
                v-model="form.roomsPrices[index].cleanerCost"
                :min="0"
                :disabled="isDisabled"
                placeholder="Ставка"
                class="w-full" />
            </div>
          </div>

          <div class="form__field_few last">
            <div class="form__field">
              <span
                :class="{ 'form__field-label_hidden': form.baseCost === '' || form.baseCost === undefined }"
                class="form__field-label form__field-label_select">
                Стоимость не менее
              </span>
              <vs-input-number
                v-model="form.baseCost"
                :min="0"
                :disabled="isDisabled"
                placeholder="Стоимость не менее"
                class="w-full" />
            </div>
            <div class="form__field">
              <span
                :class="{ 'form__field-label_hidden': form.cleanerCost === '' || form.cleanerCost === undefined }"
                class="form__field-label form__field-label_select">
                Ставка не менее
              </span>
              <vs-input-number
                v-model="form.cleanerCost"
                :min="0"
                :disabled="isDisabled"
                placeholder="Ставка не менее"
                class="w-full" />
            </div>
          </div>
        </div>

        <template v-for="lvl in 3">
          <div
            v-if="form.isSubscribeAvailable"
            :key="lvl"
            class="form__column right-line">
            <div class="form__field title line">
              <p>{{ subscribeLvls[lvl] }}</p>
            </div>
            <div
              v-for="index in 5"
              :key="index"
              :class="{ 'last': index === 5 }"
              class="form__field_few">
              <div class="form__field">
                <span
                  :class="{ 'form__field-label_hidden': form.roomsPrices[index][`baseCost${lvl}`] === '' || form.roomsPrices[index][`baseCost${lvl}`] === undefined }"
                  class="form__field-label form__field-label_select">
                  Цена
                </span>
                <vs-input-number
                  v-model="form.roomsPrices[index][`baseCost${lvl}`]"
                  :min="0"
                  :disabled="isDisabled"
                  placeholder="Цена"
                  class="w-full" />
              </div>
              <div class="form__field">
                <span
                  :class="{ 'form__field-label_hidden': form.roomsPrices[index][`cleanerCost${lvl}`] === '' || form.roomsPrices[index][`cleanerCost${lvl}`] === undefined }"
                  class="form__field-label form__field-label_select">
                  Ставка
                </span>
                <vs-input-number
                  v-model="form.roomsPrices[index][`cleanerCost${lvl}`]"
                  :min="0"
                  :disabled="isDisabled"
                  placeholder="Ставка"
                  class="w-full" />
              </div>
            </div>
          </div>
        </template>

        <div class="form__column clean-time">
          <div class="form__field title">
            <p />
          </div>
          <div
            v-for="index in 5"
            :key="index"
            class="form__field">
            <span
              class="form__field-label form__field-label_select">
              Время уборки
            </span>
            <vue-timepicker
              v-model="form.roomsPrices[index].cleanTime"
              hide-clear-button
              :minute-interval="5"
              :class="errors.has(`roomPrices${index}.cleanTime`) ? 'validate-error' : ''"
              :disabled="isDisabled"
              :name="`roomPrices${index}.cleanTime`" />
          </div>
        </div>

      </div>

      <div
        v-else-if="form.unitType === 'm2'"
        class="form service-price">
        <div class="form__column">
          <div class="form__field">
            <span
              :class="{ 'form__field-label_hidden': form.minCost === '' || form.minCost === undefined }"
              class="form__field-label form__field-label_select">
              Минимальная стоимость заказа, ₽
            </span>
            <vs-input-number
              v-model="form.minCost"
              :min="0"
              :disabled="isDisabled"
              placeholder="Минимальная стоимость заказа, ₽"
              class="w-full" />
          </div>
        </div>
        <div class="form__column">
          <div class="form__field">
            <span
              :class="{ 'form__field-label_hidden': form.unitPrice === '' || form.unitPrice === undefined }"
              class="form__field-label form__field-label_select">
              Стоимось юнита
            </span>
            <vs-input-number
              v-model="form.unitPrice"
              :min="0"
              :disabled="isDisabled"
              placeholder="Стоимось юнита"
              class="w-full" />
          </div>
        </div>
        <div class="form__column">
          <div class="form__field">
            <span
              :class="{ 'form__field-label_hidden': form.cleanerCost === '' || form.cleanerCost === undefined }"
              class="form__field-label form__field-label_select">
              Ставка клинера
            </span>
            <vs-input-number
              v-model="form.cleanerCost"
              :min="0"
              :disabled="isDisabled"
              placeholder="Ставка клинера"
              class="w-full" />
          </div>
        </div>
      </div>

      <div
        v-if="form.unitType === 'room' || form.unitType === 'm2'"
        class="form-header services">
        <div class="form-header__title">
          <span>Дополнительные услуги</span>
        </div>
      </div>

      <div
        v-if="form.unitType === 'room' || form.unitType === 'm2'"
        class="form services-checkboxes">
        <vs-checkbox
          v-for="(service, index) in services"
          :key="index"
          :disabled="isDisabled"
          v-model="form.servicesIds"
          :vs-value="service.id">
          {{ service.name }}
        </vs-checkbox>
      </div>

    </div>

  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import VueTimepicker from 'vue2-timepicker'

import servicesList from './additionalServicesList'

export default {
  name: 'ServiceForm',

  filters: {
    toDateFormat(val) {
      return moment(val).format('DD.MM.YY HH:mm')
    }
  },

  components: {
    VueTimepicker,
    servicesList
  },

  data() {
    const roomsPrices = {}
    for (let i = 1; i <= 5; i++) {
      if (!roomsPrices[i]) {
        roomsPrices[i] = {
          cleanTime: { HH: '00', mm: '00', ss: '00' }
        }
      }
    }
    return {
      form: {
        newbieCleanersCount: 0,
        universalCleanersCount: 0,
        servicesIds: [],
        roomsPrices
      },
      isEdit: false,
      validateForm: false,
      validateErrors: [],
      statuses: {
        active: {
          text: 'Услуга активна',
          color: 'primary'
        },
        unactive: {
          text: 'Услуга не активна',
          color: 'warning'
        }
      },
      unitTypes: {
        m2: 'кв.м',
        room: 'кол-во комнат',
        services: 'специальные услуги'
      },
      subscribeLvls: {
        1: 'Уборка раз в 2 недели',
        2: 'Уборка 1 раз в неделю',
        3: 'Уборка 2 раза в неделю'
      },
      services: []
    }
  },

  computed: {
    ...mapGetters({
      cities: 'city/cities',
      activeCityId: 'city/activeCityId',
      userRole: 'user/role'
    }),

    isDisabled() {
      return this.userRole !== 'admin'
    }
  },

  watch: {
    veeFields: {
      handler() {
        this.validateForm = Object.values(this.veeFields).every(value =>
          this.isEdit ? (value.changed && value.valid) || !value.changed : value.valid)
      },
      deep: true
    },
    'form.unitType'() {
      for (let i = 1; i <= 5; i++) {
        if (!this.form.roomsPrices[i]) {
          this.form.roomsPrices[i] = {}
        }
        if (!this.form.roomsPrices[i].cleanTime || Object.keys(this.form.roomsPrices[i].cleanTime).length === 0) {
          this.form.roomsPrices[i].cleanTime = { HH: '00', mm: '00', ss: '00' }
        }
      }
    }
  },

  async mounted() {
    if (this.$route.name === 'ServicesAdd') {
      this.isEdit = false
    } else {
      this.isEdit = true
      await this.fetchData()
    }
    this.fetchServices()
  },

  methods: {
    async fetchData() {
      this.$vs.loading({
        container: this.$refs.loading,
        scale: 0.45
      })

      const service = await this.$apiClient.service('services').get(this.$route.params.id)
      if (isNaN(service.newbieCleanersCount) || service.newbieCleanersCount === null) {
        service.newbieCleanersCount = 0
      }
      if (isNaN(service.universalCleanersCount) || service.universalCleanersCount === null) {
        service.universalCleanersCount = 0
      }
      if (!Array.isArray(service.servicesIds)) {
        service.servicesIds = []
      }
      service.roomsPrices = service.roomsPrices || {}
      for (let i = 1; i <= 5; i++) {
        if (!service.roomsPrices[i]) {
          service.roomsPrices[i] = {}
        }
        if (service.roomsPrices[i].cleanTime && typeof service.roomsPrices[i].cleanTime === 'string') {
          const time = service.roomsPrices[i].cleanTime
          service.roomsPrices[i].cleanTime = {
            HH: time.split(':')[0],
            mm: time.split(':')[1],
            ss: '00'
          }
        } else {
          service.roomsPrices[i].cleanTime = { HH: '00', mm: '00', ss: '00' }
        }
      }

      this.form = service

      this.$vs.loading.close(this.$refs.loading)
    },

    async fetchServices() {
      const query = {
        $limit: -1,
        type: 'additional'
      }
      if (this.isEdit && this.form.cityId) {
        query.cityId = this.form.cityId
      } else if (this.$route.query.cityId) {
        query.cityId = this.$route.query.cityId
      } else if (this.activeCityId) {
        query.cityId = this.activeCityId
      }

      this.services = await this.$apiClient.service('services').find({ query })
    },

    async onAdd() {
      const isValid = await this.$validator.validateAll()
      if (!isValid) {
        this.$vs.notify({
          title: 'Заполните данные верно',
          color: 'warning',
          time: 2500
        })
        return false
      }

      const servicesService = this.$apiClient.service('services')

      try {
        this.validateErrors = []
        const data = this.transformData({ ...this.form })
        this.form = await servicesService.create({ ...data, cityId: this.$route.query.cityId, type: 'main' })
      } catch (err) {
        this.validateErrors = Array.isArray(err.errors) ? err.errors : []
        this.$vs.notify({
          title: 'Что-то пошло не так при создании услуги',
          text: err.message,
          color: 'danger',
          time: 2500
        })
        return false
      }

      this.$vs.notify({
        title: 'Услуга добавлена',
        color: 'success',
        time: 2500
      })

      this.$router.push({ name: 'Services', params: { id: this.$route.query.cityId } })
    },

    async onEdit() {
      const isValid = await this.$validator.validateAll()
      if (!isValid) {
        this.$vs.notify({
          title: 'Заполните данные верно',
          color: 'warning',
          time: 2500
        })
        return false
      }

      const servicesService = this.$apiClient.service('services')

      try {
        this.validateErrors = []
        const data = this.transformData({ ...this.form })
        this.form = await servicesService.patch(this.form.id, {
          ...data
        })
      } catch (err) {
        this.validateErrors = Array.isArray(err.errors) ? err.errors : []
        this.$vs.notify({
          title: 'Что-то пошло не так при изменение данных услуги',
          text: err.message,
          color: 'danger',
          time: 2500
        })
        return false
      }

      this.$vs.notify({
        title: 'Услуга изменена',
        color: 'success',
        time: 2500
      })

      this.$router.push({ name: 'Services', params: { id: this.$route.query.cityId } })
    },

    transformData() {
      const obj = { ...this.form }
      if (obj.roomsPrices) {
        const rooms = { ...obj.roomsPrices }
        Object.keys(rooms).forEach(roomsCount => {
          if (rooms[roomsCount] && rooms[roomsCount].cleanTime) {
            const room = { ...rooms[roomsCount] }
            room.cleanTime = `${room.cleanTime.HH}:${room.cleanTime.mm}`
            rooms[roomsCount] = room
          }
        })
        obj.roomsPrices = rooms
      }
      return obj
    },

    onCancel() {
      this.$router.push({ name: 'Services', params: { id: this.$route.query.cityId } })
    },

    getMessage(path) {
      return this.validateErrors.find(e => e.path === path)
    },

    setServicesIds(ids) {
      this.form.servicesIds = ids
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/pages/controls/services/form.scss';
</style>
